import { SEND_WHATSAPP_URL } from '@/constants';
import { UnexpectedError } from '@/services';
import { HttpStatusCode, fromContactApi, httpClient } from '@/utils';

export const sendWhatsAppService = async (whatsApp: string, companyName: string): Promise<void> => {
  const uri = fromContactApi(SEND_WHATSAPP_URL);

  const { status } = await httpClient.post(uri, { phone: `55${whatsApp}`, company_name: companyName });

  switch (status) {
    case HttpStatusCode.ok:
      break;

    default:
      throw new UnexpectedError(status);
  }
};
